export const validationNumberRegisterOptions = {
  required: 'This field is required (此為必填欄位)',
  min: {
    value: 0.1,
    message: 'This field must be more than 0.1 (請輸入大於0.1的數字)',
  },
}

export const validationRequired = {
  required: 'This field is required (此為必填欄位)',
}
